import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "store/Reducers";
import { useGetAdverts } from "./ServerSideStates";
import { excludeFilterPropertiesOnRequest } from "helpers/ExcludeAdvertFilter";
import { Space, Typography } from "antd";
import { handleSetAdvertListFilter } from "./ClientStates";
import { Helmet } from "react-helmet-async";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import GeneralPageTitle from "apps/Common/PageTitle"

const PageTitle = () => {
  const { filter } = useSelector((state: RootState) => state.realState);
  const { Text } = Typography;
  const dispatch = useDispatch();
  const adverts = useGetAdverts(excludeFilterPropertiesOnRequest(filter));
  const params = useParams();
  const { capitalize } = useCapitalize()
  const [advertType, setAdvertType] = useState<any>(null);
  useEffect(() => {
    const currentFilter = { ...filter };
    const type = params["advertType"];
    if (type) {
      if (type.includes("gayrimenkul")) {
        currentFilter["Type"] = 1;
        setAdvertType("Gayrimenkul İlan Listesi ");
      } else if (type.includes("vasita")) {
        currentFilter["Type"] = 2;
        setAdvertType("Vasıta İlan Listesi ");
      }
    } else {
      delete currentFilter["Type"];
      setAdvertType("Tüm İlanlar");
    }
    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
  }, [params]);
  const combineCategoryName = filter?.IsSearchFilter
    ? (filter?.Title
      ? (filter?.Title || "") // Eğer Title varsa, onu kullan. Yoksa boş string döndür.
      : (filter?.categoryDisplayUrl
        ?.replace(/-/g, " ") // '-' karakterlerini boşluk ile değiştir
        .replace(/\b\w/g, (char: string) => char.toUpperCase())) || ""
    )
    : (filter?.categoryDisplayUrl
      ?.replace(/-/g, " ") // '-' karakterlerini boşluk ile değiştir
      ?.replace(/\b\w/g, (char: string) => char.toUpperCase())); // Baş harfleri büyüt, yoksa boş string






  return (
    <>
      {
        combineCategoryName &&
        <>
          <Helmet>
            <title className="capitalize">
              {combineCategoryName
                .toLowerCase()
                .split(" ")
                .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ") + " İlanları"}
            </title>
          </Helmet>
          <GeneralPageTitle textClassNames="capitalize"
            title={combineCategoryName.toLowerCase() + "  İlanları"}
            count={adverts?.data?.data?.filteredCount || "0"}
          />

        </>
      }
    </>
  );
};

export default PageTitle;
